import classNames from 'classnames'
import { useLocation } from 'react-router-dom'

import type {
  CommentTopics,
  Component,
  SidebarComponent,
} from 'services/content/types'
import Loader from 'content-components/_Primatives/Loader'
import DynamicComponent from 'components/DynamicComponent'
import ComponentWrapper from 'components/ComponentWrapper'
import CommentsModule from 'containers/CommentsModule'
import style from './style.scss'

type Props = {
  isLoading: boolean
  components: Component[]
  sidebarComponents?: SidebarComponent[]
  commentTopics?: CommentTopics
}

function MainContent({
  components,
  isLoading,
  commentTopics,
  sidebarComponents,
}: Props) {
  const location = useLocation()
  const isDaily = location.pathname === '/daily'

  return (
    <main
      id='main'
      className={classNames(style.wrapper, {
        [style.isDaily]: isDaily,
        [style.hasSidebar]: !!sidebarComponents,
      })}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {components.map((component, index) => (
            <ComponentWrapper
              key={`${component.name}_${index}`}
              component={component}
              hasSidebar={!!sidebarComponents}
            >
              <DynamicComponent component={component} />
            </ComponentWrapper>
          ))}
          {commentTopics && commentTopics.length > 0 && (
            <ComponentWrapper>
              <CommentsModule topics={commentTopics} />
            </ComponentWrapper>
          )}
          {sidebarComponents && (
            <div className={style.sidebar}>
              {sidebarComponents.map((component, index) => (
                <DynamicComponent
                  key={`${component.name}_${index}`}
                  component={component}
                />
              ))}
            </div>
          )}
        </>
      )}
    </main>
  )
}

export default MainContent
